import './Subiecte.css';

export default function Subiecte2009() {
    return (
        <div className="container my-4">
            <h2 className="fw-bold mb-4 subjectTitle">{'<'}Subiecte 2009{'/>'}</h2>
            <div className="mb-4">
                <h5>1. <strong>100 Variante</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li><a href="/subiecte/2009/100 Variante Bacalaureat Informatică 2009.pdf" target="_blank" rel="noreferrer">Subiecte C/C++</a></li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    );
}